$(document).ready(function () {

    var alertBox = $('.alert-box');
    var alertBoxClose = $('.alert-box__close');

    var showClass = "alert-box__show";

    if (localStorage.getItem("AlertClosed") === null || localStorage.getItem("AlertClosed") !== null && JSON.parse(localStorage.getItem("AlertClosed")) == false) {
        alertBox.addClass(showClass);
    }

    alertBoxClose.on('click', function () {
        alertBox.removeClass(showClass);
    });
});